import { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { getPatientDetails, updatePatient } from "../API/PatientsApi";
import AuthContext from "../Context/AuthProvider";

function UpdatePatient() {
  const auth = useContext(AuthContext);
  const [errorMessage, setErrorMessage] = useState();
  const location = useLocation();
  const [patientToEdit, setPatientToEdit] = useState();
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [prefix, setPrefix] = useState();
  const [dob, setDob] = useState();
  const [gender, setGender] = useState();
  const [mobileNo, setMobileNo] = useState();
  const [nationalId, setNationalId] = useState();
  const [nationalIdType, setNationalIdType] = useState();
  const [emailId, setEmailId] = useState();
  const [bloodGroup, setBloodGroup] = useState();
  const [emergencyContactPerson, setEmergencyContactPerson] = useState();
  const [emergencyContactPhoneNumber, setEmergencyContactPhoneNumber] =
    useState();
  const [addressHouseNo, setAddressHouseNo] = useState();
  const [addressStreet, setAddressStreet] = useState();
  const [addressPIN, setAddressPIN] = useState();
  const [addressCountry, setAddressCountry] = useState();
  const [addressState, setAddressState] = useState();
  const [addressCity, setAddressCity] = useState();
  const [patientId, setPatientId] = useState();
  const [photoBase64Url, setPhotoBase64Url] = useState();

  useEffect(() => {
    const loadPatient = async () => {
      setPatientId(location?.state);
      const result = await getPatientDetails(auth, location?.state);
      if (result.isSuccess) {
        setPatientToEdit(result?.data);
        setPrefix(result?.data?.prefix);
        setFirstName(result?.data?.firstName);
        setLastName(result?.data?.lastName);
        setGender(result?.data?.gender);
        setDob(result?.data?.dateOfBirth.split("T")[0]);
        setEmailId(result?.data?.emailId);
        setMobileNo(result?.data?.mobileNo);
        //photo
        setBloodGroup(result?.data?.bloodGroup);
        setEmergencyContactPerson(result?.data?.emergencyContactPerson);
        setEmergencyContactPhoneNumber(
          result?.data?.emergencyContactPhoneNumber
        );
        setAddressHouseNo(result?.data?.addressHouseNo);
        setAddressStreet(result?.data?.addressStreet);
        setAddressPIN(result?.data?.addressPIN);
        setAddressCountry(result?.data?.addressCountry);
        setAddressState(result?.data?.addressState);
        setAddressCity(result?.data?.addressCity);
        setPhotoBase64Url(result?.data?.photo);
      } else {
        console.log(result.data);
      }
    };
    //alert(location?.state?.id);

    loadPatient();
  }, [auth, location?.state]);

  const savePatientInfo = async (e) => {
    e.preventDefault();
    // if(photoPath)
    // {
    //   console.log(photoBase64Url);
    // }
    const patient = {
      firstName: firstName,
      lastName: lastName,
      gender: gender,
      dateOfBirth: dob,
      emailId: emailId,
      mobileNo: mobileNo,
      isActive: true,
      prefix: prefix,
      photo: photoBase64Url,
      bloodGroup: bloodGroup,
      emergencyContactPerson: emergencyContactPerson,
      emergencyContactPhoneNumber: emergencyContactPhoneNumber,
      addressHouseNo: addressHouseNo,
      addressStreet: addressStreet,
      addressPIN: addressPIN,
      addressCountry: addressCountry,
      addressState: addressState,
      addressCity: addressCity,
    };
    //alert(JSON.stringify(patient));
    //alert(auth);
    var result = await updatePatient(auth?.auth, patientId, patient);
    alert(JSON.stringify(result));
    //validateInputs();
    //alert("saved");
  };

  // const validateInputs = () => {
  //   var errorList = [];
  //   if(firstName === "")
  //   {
  //     errorList.push("First Name is a mandatory field");
  //   }
  //   if(lastName === "")
  //   {
  //     errorList.push("Last Name is a mandatory field");
  //   }
  //   if(!dob || new Date(dob) > new Date())
  //   {
  //     errorList.push("The date of birth is a mandatory field and cannot be a future date.")
  //   }
  //   var message = ""
  //   if(errorList.length > 3)
  //   {
  //     message = "There are many error in filling the form. The first 3 are below.";
  //   }

  //   errorList.forEach(item => {
  //     message += item + "\n";
  //   });

  // if(message !== "")
  // {
  //   setErrorMessage(message);
  //   errorToast.show();
  //   return false;
  // }
  // else
  // {
  //   return true;
  // }

  //}

  // useEffect(() => {
  //   //setPatientToEdit(location?.state);
  //   setSalutation(location?.state?.salutation);
  //   setFirstName(location?.state?.firstName);
  //   setLastName(location?.state?.lastName);
  //   setGender(location?.state?.gender);
  //   setDob(location?.state?.dateOfBirth.split("T")[0]);
  //   setEmailId(location?.state?.emailId);
  // }, [location?.state]);

  return (
    <div class="container-fluid">
      <div class="container">
        {!patientId?
        <><label>There is no patient</label></> :
        <>
        <div class="row mt-2">
          <div class="col-3 justify-content-start">
            {/* <nav aria-label="breadcrumb">
              <ol class="breadcrumb overflow-visible flex-nowrap">
                <li class="breadcrumb-item flex-nowrap">
                  <Link to="/appointmentshome">Appointments</Link>
                </li>
                <li class="breadcrumb-item">
                  <Link to="/patientdetails" state={patientToEdit?.id}>
                    {patientToEdit?.firstName}'s Details
                  </Link>
                </li>
                <li
                  class="breadcrumb-item active flex-nowrap"
                  aria-current="page"
                >
                  Update
                </li>
              </ol>
            </nav> */}
          </div>
          <div class="col-6 g-0 d-flex justify-content-center">
            <h5>Update {patientToEdit?.firstName}'s Details</h5>
          </div>
          <div class="col-3"></div>
        </div>
        <form
          noValidate
          class="was-validated"
          onSubmit={savePatientInfo}
        >
          <div class="row justify-content-center align-items-center mb-3">
            <div class="row justify-content-center align-items-end mb-3">
              <div class="col-2"></div>
              <div class="col-4">
                <label>Profile Photo</label>

                <input
                  class="form-control "
                  id="profilePhotoFileInput"
                  type="file"
                  accept="image/png, image/gif, image/jpeg"
                  onChange={(e) => {
                    //setPhotoPath(URL.createObjectURL(e.target.files[0]));
                    if (e.target.files[0].size < 500 * 1024) {
                      var fileReader = new FileReader();
                      fileReader.readAsDataURL(e.target.files[0]);
                      fileReader.onload = () => {
                        setPhotoBase64Url(fileReader.result);
                      };
                    } else {
                      setErrorMessage("Selected file is bigger than 500 KB.");
                      const inputElement = document.getElementById(
                        "profilePhotoFileInput"
                      );
                      inputElement.value = "";
                    }
                  }}
                ></input>
              </div>
              <div class="col-1 card">
                <img
                  class="card-img-top"
                  src={photoBase64Url} 
                  height="100"
                  width="90"
                  //class="border p-1 m-1"
                  alt="Profile Pic"
                />
              </div>  
              <div class="col-3">
                <button class="btn btn-danger p-1" type="button" onClick={() =>{
                  const inputElement = document.getElementById(
                    "profilePhotoFileInput"
                  );
                  if(inputElement)
                  {
                    inputElement.value = "";
                  }
                  setPhotoBase64Url();
                }}>
                  <i class="bi bi-trash"></i>
                </button>
              </div>
              <div class="col-2">
                  </div>
            </div>
            <div class="row mb-3">
              <div class="col-2"></div>

              <div class="col-2">
                <label>Prefix</label>
                <select
                  class="form-select form-select  "
                  name=""
                  id=""
                  value={prefix}
                >
                  <option value="Mr.">Mr</option>
                  <option value="Mrs.">Mrs</option>
                  <option value="Ms.">Ms</option>
                  <option value="Dr.">Dr</option>
                </select>
              </div>
              <div class="col-3">
                <label>First Name</label>
                <input
                  class="form-control "
                  type="text"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  required
                  pattern="[A-Za-z ]{1,64}"
                ></input>
                <div class="invalid-feedback">First name cannot be blank.</div>
              </div>
              <div class="col-3">
                <label>Last Name</label>
                <input
                  class="form-control "
                  type="text"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  required
                  pattern="[A-Za-z ]{1,64}"
                ></input>
                <div class="invalid-feedback">Last name cannot be blank.</div>
              </div>
              <div class="col-2"></div>
            </div>

            <div class="row mb-3">
              <div class="col-2 d-flex justify-content-end"></div>
              <div class="col-4">
                <label>Date of Birth</label>

                <div>
                  <input
                    class="form-control "
                    type="date"
                    value={dob}
                    onChange={(e) => setDob(e.target.value)}
                    required
                  ></input>
                  <div class="invalid-feedback">
                    Date of birth cannot be blank.
                  </div>
                </div>
              </div>
              <div class="col-4">
                <label>Gender</label>
                <select
                  class="form-select form-select  "
                  value={gender}
                >
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Others">Others</option>
                </select>
              </div>
              <div class="col-2"></div>
            </div>

            <div class="row justify-content-center align-items-center">
              <div class="col-2 d-flex justify-content-end"></div>
              <div class="col-4">
                <label>Address (House No\Building Name)</label>

                <div class="mb-3 border">
                  <input
                    class="form-control "
                    rows="3"
                    type="text"
                    value={addressHouseNo}
                    onChange={(e) => setAddressHouseNo(e.target.value)}
                    pattern="[^%$*]{1,32}"
                  ></input>
                </div>
              </div>
              <div class="col-4">
                <label>Address (Street\Area)</label>

                <div class="mb-3 border">
                  <input
                    class="form-control "
                    rows="3"
                    type="text"
                    value={addressStreet}
                    onChange={(e) => setAddressStreet(e.target.value)}
                    pattern="[^%$*]{1,32}"
                  ></input>
                </div>
              </div>
              <div class="col-2"></div>
            </div>
            <div class="row justify-content-center align-items-center mb-3">
              <div class="col-2 d-flex justify-content-end"></div>
              <div class="col-4">
                <label>PIN</label>
                <input
                  class="form-control "
                  type="text"
                  value={addressPIN}
                  onChange={(e) => setAddressPIN(e.target.value)}
                  pattern="[^%$*]{1,32}"
                ></input>
              </div>
              <div class="col-4">
                <label>Country</label>
                <input
                  class="form-control "
                  type="text"
                  value={addressCountry}
                  onChange={(e) => setAddressCountry(e.target.value)}
                  pattern="[A-Za-z ]{1,32}"
                ></input>
              </div>
              <div class="col-2"></div>
            </div>
            <div class="row justify-content-center align-items-center mb-3">
              <div class="col-2 d-flex justify-content-end"></div>
              <div class="col-4">
                <label>State</label>
                <input
                  class="form-control "
                  type="text"
                  value={addressState}
                  onChange={(e) => setAddressState(e.target.value)}
                  pattern="[A-Za-z ]{1,32}"
                ></input>
              </div>
              <div class="col-4">
                <label>City</label>
                <input
                  class="form-control "
                  type="text"
                  value={addressCity}
                  onChange={(e) => setAddressCity(e.target.value)}
                  pattern="[A-Za-z ]{1,32}"
                ></input>
              </div>
              <div class="col-2"></div>
            </div>
            <div class="row mb-3">
              <div class="col-2 d-flex justify-content-end"></div>
              <div class="col-4">
                <label>Email Id</label>
                <input
                  class="form-control "
                  type="email"
                  value={emailId}
                  onChange={(e) => setEmailId(e.target.value)}
                  required
                  //pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                ></input>
                <div class="invalid-feedback">Email id is not valid.</div>
              </div>
              <div class="col-4">
                <label>Mobile No.</label>
                <input
                  class="form-control "
                  type="text"
                  value={mobileNo}
                  onChange={(e) => setMobileNo(e.target.value)}
                  required
                  pattern="[0-9]{10}"
                ></input>
                <div class="invalid-feedback">Mobile no. is not correct.</div>
              </div>
              <div class="col-2"></div>
            </div>
            <div class="row mb-3">
              <div class="col-2 d-flex justify-content-end"></div>
              <div class="col-4">
                <label>National Id</label>
                <input
                  class="form-control "
                  type="text"
                  value={nationalId}
                  onChange={(e) => setNationalId(e.target.value)}
                  pattern="[^%$*]{1,32}"
                ></input>
              </div>
              <div class="col-4">
                <label>National Id Type</label>
                <select
                  class="form-select form-select  "
                  value={nationalIdType}
                  onSelect={(e) => setNationalIdType(e.target.value)}
                >
                  <option value="Aadhar">Aadhar</option>
                  <option value="PANCard">PAN Card</option>
                  <option value="Passport">Passport</option>
                  <option value="GovernmentEmployeeId">
                    Government Employee Id
                  </option>
                </select>
              </div>
              <div class="col-2"></div>
            </div>
            <div class="row mb-3">
              <div class="col-2 d-flex justify-content-end"></div>
              <div class="col-4">
                <label>Emergency Contact Person</label>
                <input
                  class="form-control "
                  type="text"
                  value={emergencyContactPerson}
                  onChange={(e) => setEmergencyContactPerson(e.target.value)}
                  pattern="[A-Za-z ]{1,32}"
                ></input>
              </div>
              <div class="col-4">
                <label>Emergency Contact Mobile No.</label>
                <input
                  class="form-control "
                  type="text"
                  value={emergencyContactPhoneNumber}
                  onChange={(e) =>
                    setEmergencyContactPhoneNumber(e.target.value)
                  }
                  pattern="[0-9]{10}"
                ></input>
              </div>
              <div class="col-2"></div>
            </div>
            <div class="row mb-3">
              <div class="col-2 d-flex justify-content-end"></div>

              <div class="col-4">
                <label>Blood Group</label>
                <select
                  class="form-select form-select  "
                  value={bloodGroup}
                >
                  <option value="aPositive">A+</option>
                  <option value="bPositive">B+</option>
                  <option value="oPositive">O+</option>
                  <option value="abPositive">AB+</option>
                  <option value="aNegative">A-</option>
                  <option value="bNegative">B-</option>
                  <option value="oNegative">O-</option>
                  <option value="abNegative">AB-</option>
                </select>
              </div>
              <div class="col-4">
                {/* <label>Can we contact in case of blodd donation need?</label>
                  <input
                    class="form-control border-secondary"
                    type="text"
                    value={bloddDonationConsent}
                    onChange={(e) => setBloddDonationConsent(e.target.value)}
                  ></input> */}
              </div>
              <div class="col-2"></div>
            </div>
          </div>

          <div class="row justify-content-center align-items-center">
            <div class="col-2"></div>
            <div class="col-8"></div>
            <div class="col-2"></div>
          </div>

          <div class="row justify-content-center align-items-center">
            <div class="col-2 d-flex justify-content-end"></div>
            <div class="col-8 d-flex justify-content-center mb-5">
              <button class="btn btn-secondary ms-1">Back</button>
              <button
                class="btn btn-primary ms-4"
                //type="submit"
                //onSubmit={(e) => savePatientInfo(e)}
              >
                Save
              </button>
            </div>
            <div class="col-2"></div>
          </div>
        </form>
        </>
        }
      </div>
    </div>
  );
}
export default UpdatePatient;
